(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/news/assets/javascripts/collections/news-list.js') >= 0) return;  svs.modules.push('/components/sport/news/assets/javascripts/collections/news-list.js'); 
'use strict';

(function(Backbone, _, svs) {
  svs.sport.news.collections.NewsList = Backbone.Collection.extend({
    model: svs.sport.news.models.NewsArticle,

    const: {
      CREATED: 'created',
      PUBLISHED: 'published',
      RESULT: 'result',
      DESC: 'desc',
      MOBILE: 'mobile',
      DESKTOP: 'desktop',
      TRINIDAD: 'trindad'
    },

    initialize: function(model, options) {
      options = _.extend({}, options);

      if (!_.has(options, 'domainCategories')) {
        svs.sport.news.log.warn(
          'Any of the following was not provided options.domainCategories.',
          this
        );
        return;
      }

      this.parentId = options.parentId || 'svs-workarea-articles-newstt';
      this.domainCategories = options.domainCategories;
      this.sortAlgo = this.const.PUBLISHED + ':' + this.const.DESC;
      this.numOfArticles = options.numOfArticles || '10';

      this.isFetched = false;
    },

    url: function() {
      if (!this.parentId || !this.domainCategories || !this.numOfArticles) {
        svs.sport.news.log.warn(
          'Any of the following was not defined parentId, domainCategories, numOfArticles when trying to fetch.',
          this
        );
      }

      return (
        svs.core.jupiter.url() +
        new svs.content.shared.ContentUrlBuilder('basicfilter')
          .addParams({
            parentId: this.parentId,
            domainCategories: this.domainCategories,
            sort: this.sortAlgo,
            count: this.numOfArticles
          })
          .build()
      );
    },

    parse: function(data) {
      var result;
      if (_.has(data, this.const.RESULT)) {
        result = data.result;
      } else {
        result = data;
      }
      this.isFetched = true;
      return result;
    }
  });
})(Backbone, _, svs);

 })(window);